import { firestoreRef, authRef } from 'api';

const examsRef = firestoreRef.collection('exams');

export async function getPublishedExams() {
  return (await examsRef
    .where('status', '==', 'ended')
    .orderBy('startDate', 'desc')
    .get()).docs.map(d => d.data());
}

export async function getTop10ResultForExam(examKey) {
  return (await examsRef
    .doc(examKey)
    .collection('results')
    .orderBy('rank', 'asc')
    .limit(10)
    .get()).docs.map(d => d.data());
}

export async function getResult(examKey, rollNumber) {
  var docs = (await examsRef
    .doc(examKey)
    .collection('results')
    .where('rollNumber', '==', rollNumber)
    .limit(1)
    .get()).docs;
  if (docs.length > 0) return docs[0].data();
}

export async function getMyResult(examKey) {
  console.log('@@uid', authRef.currentUser.uid);
  return (await examsRef
    .doc(examKey)
    .collection('results')
    .doc(authRef.currentUser.uid)
    .get()).data();
}

export async function getAllResult(examKey) {
  return (await examsRef
    .doc(examKey)
    .collection('results')
    .orderBy('rank', 'asc')
    .get()).docs.map(d => d.data());
}

export const getSearchResult = async value => {
  if (value) {
    let examResult = [];
    examResult = (await examsRef
      .where('status', '==', 'ended')
      .orderBy('name')
      .startAt(value)
      .get()).docs.map(d => d.data());
    return examResult;
  }
  return false;
};
